import request from './request';

const http = {
  get(url, parameters) {
    const config = {
      method: 'get',
      url,
    };
    if (parameters) {
      config.params = parameters;
    }

    return request(config);
  },

  post(url, parameters) {
    const config = {
      method: 'post',
      url,
    };
    if (parameters) {
      config.data = parameters;
    }

    return request(config);
  },
};

export default http;
